exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-data-table table{border-bottom:1px solid #ddd}", ""]);
